import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../shared/services/general.service';

@Component({
  selector: 'app-gui-layout',
  templateUrl: './gui-layout.component.html',
  styleUrls: ['./gui-layout.component.scss']
})
export class GuiLayoutComponent implements OnInit {
  sidebarActive: Boolean = false;
  constructor(private generalService: GeneralService) { }

  ngOnInit() {
  }

  isMobile() {
    return this.generalService.isMobile();
  }

  isWindowsPhone() {
    return this.generalService.isWindowsPhone();
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/gui-layout/gui-layout.component.ts